export const BASE_URL =
  process.env.NEXT_PUBLIC_BASE_URL || "https://localhost:8000"
export const IMG_URL =
  process.env.NEXT_PUBLIC_BASE_IMG_URL || "https://localhost:8000"
export const MARKDOWN_IMG_URL =
  process.env.NEXT_PUBLIC_MARKDOWN_IMG_URLS || "https://localhost:8000,https://localhost:8000"


export const SEO_DEFAULT = {
  metaTitle: null,
  metaDescription: null,
  structuredData: null,
  keywords: null,
  metaImage: null
}